// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Body */
body {
    font-family: "Roboto", Arial, Verdana, Helvetica, sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

ul,
li,
h1,
h6 {
    margin: 0;
    padding: 0;
}

ul {
    list-style-type: none;
}

* {
    box-sizing: border-box;
}

/* Layout */
.page-wrapper {
    max-width: 100vw;
    min-height: 100vh;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: auto 1fr;
}

.header {
    padding: 1.5rem 3rem;
    grid-column: span 2;
    background-color: #304FFE;
    font-size: 3rem;
    display: flex;
    flex-flow: row wrap;
    gap: 1rem;
}

.sidebar {
    background-color: #ECEFF1;
    padding: 3rem 0.5rem;
}

.content {
    background-color: #FBFBFB;
}

.footer {
    padding: 1.25rem 0;
    background-color: #E8EAF6;
    text-align: center;
    grid-column: span 2;
}

/* Header */
.page-title {
    color: #FBFBFB;
    font-size: inherit;
    margin: 0;
    padding: 0;
    font-family: inherit;
    font-weight: bold;
}

.page-logo {
    font-size: inherit;
    color: #FBFBFB;
    margin: 0;
}

/* Sidebar */
.sidebar-task,
.sidebar-project,
.sidebar-project-items {
    display: flex;
    flex-flow: column wrap;
}

.sidebar-task {
    margin: 0 0 2rem;
}

.sidebar-title {
    font-size: 1.5rem;
    font-family: inherit;
    font-weight: bold;
    margin: 1rem 2rem;
}

.nav-item {
    width: 280px;
    font-size: 1rem;
    font-family: inherit;
    margin: 0 0 1rem;
    border: none;
    background-color: transparent;
    overflow: hidden;
    display: inline-block;
    text-align: left;
    cursor: pointer;
    padding: 0.5rem 4rem 0.5rem 2rem;
    text-transform: capitalize;
    transition: background 0.3s ease;
}

.nav-item:hover,
.nav-item:active {
    background-color: #E0E0E0;
}

.nav-item.active {
    background-color: #BBDEFB;
}

.sidebar-project {
    margin: 2rem 0 0;
}

.nav-icon {
    margin-right: 0.5rem;
}

.project-form {
    display: flex;
    flex-flow: column wrap;
    gap: 1rem;
    margin: 0 1rem 2rem;
}

.form-control {
    font-size: 1rem;
    font-family: inherit;
    color: #304FFE;
    font-weight: bold;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: border-color 0.3s, box-shadow 0.3s;
}

.form-control::placeholder {
    color: #332D2D;
    font-weight: normal;
}

.form-control:focus {
    outline: none;
    border-color: #304FFE;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.group-btn {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    gap: 1.5rem;
}

.add-btn,
.cancel-btn {
    display: inline-block;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    overflow: hidden;
    outline: none;
    border: 0;
    cursor: pointer;
    color: #FBFBFB;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
    text-transform: capitalize;
    transition: box-shadow 0.3s ease-in-out;
}

.add-btn {
    background-color: #304FFE;
}

.cancel-btn {
    background-color: #FBFBFB;
    color: #304FFE;
}

.add-btn:hover,
.add-btn:active,
.cancel-btn:hover,
.cancel-btn:active {
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 2px 5px rgba(0, 0, 0, 0.1);
}

.action-btn-icon {
    margin: 0 0.5rem 0 0;
}

.project-item {
    display: flex;
    flex-flow: row wrap;
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    font-size: 1rem;
}

.project-item-body,
.project-item-actions {
    display: inline-block;
}

.project-action-btn {
    display: inline-block;
    visibility: hidden;
    cursor: pointer;
    border: none;
    background-color: transparent;
    margin-right: 0.5rem;
    font-size: 1.25rem;
}

/* Content */
.content {
    display: flex;
    flex-flow: column wrap;
    align-items: start;
    padding: 3rem 6rem;
}

.content-title {
    font-size: 2rem;
    margin: 0 0 2rem;
    text-transform: capitalize;
}

.add-task-btn {
    display: inline-block;
    overflow: hidden;
    cursor: pointer;
    background-color: #ECEFF1;
    padding: 0.75rem 6rem 0.75rem 1rem;
    border: none;
    outline: none;
    margin: 1rem 0;
    font-size: 1.25rem;
    text-align: left;
    transition: background 0.3s ease;
}

.add-task-btn:hover,
.add-task-btn:active {
    background-color: #E0E0E0;
}

.add-task-icon {
    margin-right: 1rem;
}

.insert-task-form {
    width: 90%;
    margin: 2rem auto;
    display: flex;
    flex-flow: column wrap;
    background-color: #ECEFF1;
    border-radius: 1rem;
    padding: 2rem 3rem;
    gap: 1.5rem;
}

.task-details,
.task-metadata {
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
    gap: 2rem;
}

.insert-task-form .form-control {
    flex-grow: 1;
}

.insert-task-form .group-btn {
    gap: 3rem;
}

/* Task */
.task-container {
    width: 100%;
    margin: 0;
}

.task {
    width: 80%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    background-color: #ECEFF1;
    color: #332D2D;
    font-size: 1rem;
    padding: 0.5rem 1.5rem;
    margin: 0 0 1rem;
    border-radius: 1rem;
}

.task.critical-priority {
    background-color: #FFEBEE;
}

.task.high-priority {
    background-color: #FFF3E0;
}

.task.medium-priority {
    background-color: #FFFDE7;
}

.task.low-priority {
    background-color: #E3F2FD;
}

.task.completed {
    background-color: #DCEDC8;
}

.task-status {
    margin-right: 2rem;
}

.task-status-checkbox {
    appearance: none;
    /* Hide the default look of the checkbox*/
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
    border: 2px solid #304FFE;
    border-radius: 0.5rem;
    transition: border-color 0.3s ease;
}

.task-status-checkbox:hover {
    background-color: white;
}

.task-status-checkbox:checked {
    background-color: #14A44D;
    border-color: #14A44D;
}

.task-body {
    margin-right: auto;
}

.task-title,
.task-description {
    margin: 0;
    font-size: 1rem;
}

.task.completed .task-title,
.task.completed .task-description {
    text-decoration: line-through;
}

.task-title {
    font-weight: bold;
    margin-bottom: 0.5rem;
}

.task-description {
    font-weight: normal;
}

.task-action {
    display: flex;
    align-items: center;
}

.task-action-date,
.task-action-btn {
    cursor: pointer;
    padding: 0.5rem 1rem;
    border: none;
    background-color: transparent;
    overflow: hidden;
    transition: background 0.3s ease;
}

.task-action-date {
    font-size: 1rem;
    border-radius: 0.25rem;
}

.task-action-btn {
    display: inline-block;
    margin-left: 1rem;
    border-radius: 0.5rem;
}

.task.completed .task-action-date,
.task.completed .edit-btn {
    opacity: 0.5;
}

.task-action-date:hover,
.task-action-date:active,
.task-action-btn:hover,
.task-action-btn:active {
    background-color: white;
}

.task.completed .task-action-date:hover,
.task.completed .edit-btn:hover {
    background-color: transparent;
    cursor: default;
}

.task-icon {
    font-size: 1.5rem;
}

/* Modal */
.task-modal {
    width: min(1000px, 98vw);
    background-color: #FBFBFB;
    border: none;
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
    padding: 1rem;
}

.task-modal .modal-header {
    display: flex;
    align-items: center;
}

.task-modal .close-btn {
    text-align: center;
    flex-grow: 0;
    margin-left: auto;
    cursor: pointer;
    border: none;
    background-color: transparent;
    color: #9E9E9E;
    font-size: 1.5rem;
    transition: color 0.3s ease;
}

.task-modal .close-btn:hover,
.task-modal .close-btn:active {
    color: #262626;
}

.task-modal .modal-title {
    font-weight: bold;
    font-size: 1.5rem;
    margin: 0;
    text-align: center;
    flex-grow: 1;
}

.task-modal .modal-title::first-letter {
    text-transform: uppercase;
}

::backdrop {
    background-color: #CFD8DC;
    opacity: 0.5;
}

/* Footer */
.footer-text {
    font-size: 1rem;
    font-weight: normal;
    color: #757575;
    font-family: inherit;
}

/* Animation */
.btn {
    position: relative;
    overflow: hidden;
}

.btn span {
    position: absolute;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.8);
    width: 100px;
    height: 100px;
    margin-top: -50px;
    margin-left: -50px;
    animation: ripple 1s;
    opacity: 0;
}

/* Add animation */
@keyframes ripple {
    from {
        opacity: 1;
        transform: scale(0);
    }

    to {
        opacity: 0;
        transform: scale(10);
    }
}

/* HD+ Devices */
@media only screen and (max-width: 1910px) {
    .sidebar {
        padding: 2rem 0.5rem;
    }

    .task {
        width: 90%;
    }

    .content {
        padding: 2rem 4rem;
    }
}

/* HD Devices */
@media only screen and (max-width: 1590px) {
    .sidebar {
        padding: 2rem 0.5rem;
    }

    .task {
        width: 100%;
    }

    .content {
        padding: 2rem 4rem;
    }
}

/* Large Devices */
@media only screen and (max-width: 1199px) {

    /* Layout */
    .sidebar {
        padding: 1.5rem 0.5rem;
    }

    .footer {
        padding: 1rem 0;
    }

    /* Sidebar */
    .sidebar-task {
        margin: 0 0 1rem;
    }

    .sidebar-title {
        font-size: 1.25rem;
        margin: 0.75rem 2rem;
    }

    .nav-item,
    .project-item {
        width: 220px;
        font-size: 0.75rem;
        margin: 0 0 0.7rem;
    }

    .nav-item {
        padding: 0.35rem 3rem 0.35rem 1.5rem;
    }

    .project-item {
        padding: 0.35rem 0.25rem 0.35rem 0.75rem;
        gap: 1rem;
    }

    .project-action-btn {
        font-size: 1rem;
    }

    .project-form {
        margin: 0 0.75rem 1rem;
    }

    .form-control {
        font-size: 0.75rem;
        padding: 6px 10px;
    }

    .add-btn,
    .cancel-btn {
        padding: 0.5rem 1rem;
        font-size: 0.75rem;
    }

    /* Content */
    .content {
        padding: 1.5rem 3rem;
    }

    .content-title {
        font-size: 1.5rem;
    }

    .add-task-btn {
        padding: 0.5rem 4rem 0.5rem 1rem;
        font-size: 1rem;
    }

    .insert-task-form {
        width: 100%;
        margin: 1.5rem auto;
        padding: 1.5rem 2rem;
        gap: 1rem;
    }

    .task-details,
    .task-metadata {
        gap: 1.5rem;
    }

    .insert-task-form .group-btn {
        gap: 2rem;
    }

    /* Task */
    .task {
        width: 100%;
        font-size: 0.75rem;
        padding: 0.5rem 1rem;
    }

    .task-status-checkbox {
        width: 1rem;
        height: 1rem;
    }

    .task-title,
    .task-description {
        font-size: 0.75rem;
    }

    .task-action-date,
    .task-action-btn {
        padding: 0.35rem 0.7rem;
    }

    .task-action-date {
        font-size: 0.75rem;
    }
    
    .task-icon {
        font-size: 1rem;
    }

    /* Footer */
    .footer-text {
        font-size: 0.75rem;
    }
}

/* Medium Devices */
@media only screen and (max-width: 991px) {
    .sidebar-project {
        margin: 0;
    }

    /* Content */
    .content {
        padding: 1rem;
    }
}

/* Small Devices */
@media only screen and (max-width: 767px) {
    /* Layout */
    .page-wrapper {
        display: flex;
        flex-flow: column wrap;
    }

    .header {
        padding: 1rem 0;
        font-size: 2rem;
        justify-content: center;
    }

    .sidebar {
        display: flex;
        flex-flow: row nowrap;
        padding: 2rem 0;
    }

    .content {
        margin-bottom: auto;
    }

    /* Sidebar */
    .sidebar-task, 
    .sidebar-project {
        flex-grow: 1;
    }

    .sidebar-task {
        margin: 0;
    }

    .sidebar-title {
        margin: 0 0 1rem;
        text-align: center;
    }

    .nav-item,
    .project-item {
        width: 100%;
    }

    /* Content */
    .content {
        padding: 1rem 0;
    }

    /* Task */
    .task {
        display: grid;
        grid-template-rows: auto auto;
        grid-template-columns: auto 1fr;
    }

    .task-action {
        grid-column: span 2;
        margin-top: 0.5rem;
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA,SAAS;AACT;IACI,4DAA4D;IAC5D,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;;;;IAII,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,aAAa;IACb,iCAAiC;IACjC,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA,YAAY;AACZ;;;IAGI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,wCAAwC;IACxC,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;;IAEI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,eAAe;IACf,cAAc;IACd,uEAAuE;IACvE,0BAA0B;IAC1B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;IAII,wEAAwE;AAC5E;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA,SAAS;AACT;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;IACf,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;;;IAII,uBAAuB;AAC3B;;AAEA;;IAEI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;IACZ,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;AACd;;AAEA,kBAAkB;AAClB;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,oBAAoB;IACxB;AACJ;;AAEA,gBAAgB;AAChB;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,eAAe;AACf;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,kBAAkB;AAClB;;IAEI,WAAW;IACX;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA,YAAY;IACZ;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;;QAEI,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,wCAAwC;QACxC,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;;QAEI,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA,YAAY;IACZ;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gCAAgC;QAChC,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,oBAAoB;QACpB,SAAS;IACb;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA,SAAS;IACT;QACI,WAAW;QACX,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA,WAAW;IACX;QACI,kBAAkB;IACtB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,SAAS;IACb;;IAEA,YAAY;IACZ;QACI,aAAa;IACjB;AACJ;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA,YAAY;IACZ;;QAEI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;IACf;;IAEA,YAAY;IACZ;QACI,eAAe;IACnB;;IAEA,SAAS;IACT;QACI,aAAa;QACb,6BAA6B;QAC7B,+BAA+B;IACnC;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,uBAAuB;IAC3B;AACJ","sourcesContent":["/* Body */\r\nbody {\r\n    font-family: \"Roboto\", Arial, Verdana, Helvetica, sans-serif;\r\n    box-sizing: border-box;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nul,\r\nli,\r\nh1,\r\nh6 {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nul {\r\n    list-style-type: none;\r\n}\r\n\r\n* {\r\n    box-sizing: border-box;\r\n}\r\n\r\n/* Layout */\r\n.page-wrapper {\r\n    max-width: 100vw;\r\n    min-height: 100vh;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: grid;\r\n    grid-template-rows: auto 1fr auto;\r\n    grid-template-columns: auto 1fr;\r\n}\r\n\r\n.header {\r\n    padding: 1.5rem 3rem;\r\n    grid-column: span 2;\r\n    background-color: #304FFE;\r\n    font-size: 3rem;\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    gap: 1rem;\r\n}\r\n\r\n.sidebar {\r\n    background-color: #ECEFF1;\r\n    padding: 3rem 0.5rem;\r\n}\r\n\r\n.content {\r\n    background-color: #FBFBFB;\r\n}\r\n\r\n.footer {\r\n    padding: 1.25rem 0;\r\n    background-color: #E8EAF6;\r\n    text-align: center;\r\n    grid-column: span 2;\r\n}\r\n\r\n/* Header */\r\n.page-title {\r\n    color: #FBFBFB;\r\n    font-size: inherit;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: inherit;\r\n    font-weight: bold;\r\n}\r\n\r\n.page-logo {\r\n    font-size: inherit;\r\n    color: #FBFBFB;\r\n    margin: 0;\r\n}\r\n\r\n/* Sidebar */\r\n.sidebar-task,\r\n.sidebar-project,\r\n.sidebar-project-items {\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n}\r\n\r\n.sidebar-task {\r\n    margin: 0 0 2rem;\r\n}\r\n\r\n.sidebar-title {\r\n    font-size: 1.5rem;\r\n    font-family: inherit;\r\n    font-weight: bold;\r\n    margin: 1rem 2rem;\r\n}\r\n\r\n.nav-item {\r\n    width: 280px;\r\n    font-size: 1rem;\r\n    font-family: inherit;\r\n    margin: 0 0 1rem;\r\n    border: none;\r\n    background-color: transparent;\r\n    overflow: hidden;\r\n    display: inline-block;\r\n    text-align: left;\r\n    cursor: pointer;\r\n    padding: 0.5rem 4rem 0.5rem 2rem;\r\n    text-transform: capitalize;\r\n    transition: background 0.3s ease;\r\n}\r\n\r\n.nav-item:hover,\r\n.nav-item:active {\r\n    background-color: #E0E0E0;\r\n}\r\n\r\n.nav-item.active {\r\n    background-color: #BBDEFB;\r\n}\r\n\r\n.sidebar-project {\r\n    margin: 2rem 0 0;\r\n}\r\n\r\n.nav-icon {\r\n    margin-right: 0.5rem;\r\n}\r\n\r\n.project-form {\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    gap: 1rem;\r\n    margin: 0 1rem 2rem;\r\n}\r\n\r\n.form-control {\r\n    font-size: 1rem;\r\n    font-family: inherit;\r\n    color: #304FFE;\r\n    font-weight: bold;\r\n    background-color: #fff;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    padding: 8px 12px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    transition: border-color 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.form-control::placeholder {\r\n    color: #332D2D;\r\n    font-weight: normal;\r\n}\r\n\r\n.form-control:focus {\r\n    outline: none;\r\n    border-color: #304FFE;\r\n    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);\r\n}\r\n\r\n.group-btn {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: center;\r\n    gap: 1.5rem;\r\n}\r\n\r\n.add-btn,\r\n.cancel-btn {\r\n    display: inline-block;\r\n    padding: 0.5rem 1rem;\r\n    font-size: 1rem;\r\n    overflow: hidden;\r\n    outline: none;\r\n    border: 0;\r\n    cursor: pointer;\r\n    color: #FBFBFB;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n    text-transform: capitalize;\r\n    transition: box-shadow 0.3s ease-in-out;\r\n}\r\n\r\n.add-btn {\r\n    background-color: #304FFE;\r\n}\r\n\r\n.cancel-btn {\r\n    background-color: #FBFBFB;\r\n    color: #304FFE;\r\n}\r\n\r\n.add-btn:hover,\r\n.add-btn:active,\r\n.cancel-btn:hover,\r\n.cancel-btn:active {\r\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.action-btn-icon {\r\n    margin: 0 0.5rem 0 0;\r\n}\r\n\r\n.project-item {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    padding: 0.5rem 0.5rem 0.5rem 1rem;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 2rem;\r\n    font-size: 1rem;\r\n}\r\n\r\n.project-item-body,\r\n.project-item-actions {\r\n    display: inline-block;\r\n}\r\n\r\n.project-action-btn {\r\n    display: inline-block;\r\n    visibility: hidden;\r\n    cursor: pointer;\r\n    border: none;\r\n    background-color: transparent;\r\n    margin-right: 0.5rem;\r\n    font-size: 1.25rem;\r\n}\r\n\r\n/* Content */\r\n.content {\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    align-items: start;\r\n    padding: 3rem 6rem;\r\n}\r\n\r\n.content-title {\r\n    font-size: 2rem;\r\n    margin: 0 0 2rem;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.add-task-btn {\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    cursor: pointer;\r\n    background-color: #ECEFF1;\r\n    padding: 0.75rem 6rem 0.75rem 1rem;\r\n    border: none;\r\n    outline: none;\r\n    margin: 1rem 0;\r\n    font-size: 1.25rem;\r\n    text-align: left;\r\n    transition: background 0.3s ease;\r\n}\r\n\r\n.add-task-btn:hover,\r\n.add-task-btn:active {\r\n    background-color: #E0E0E0;\r\n}\r\n\r\n.add-task-icon {\r\n    margin-right: 1rem;\r\n}\r\n\r\n.insert-task-form {\r\n    width: 90%;\r\n    margin: 2rem auto;\r\n    display: flex;\r\n    flex-flow: column wrap;\r\n    background-color: #ECEFF1;\r\n    border-radius: 1rem;\r\n    padding: 2rem 3rem;\r\n    gap: 1.5rem;\r\n}\r\n\r\n.task-details,\r\n.task-metadata {\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-flow: row wrap;\r\n    gap: 2rem;\r\n}\r\n\r\n.insert-task-form .form-control {\r\n    flex-grow: 1;\r\n}\r\n\r\n.insert-task-form .group-btn {\r\n    gap: 3rem;\r\n}\r\n\r\n/* Task */\r\n.task-container {\r\n    width: 100%;\r\n    margin: 0;\r\n}\r\n\r\n.task {\r\n    width: 80%;\r\n    display: flex;\r\n    flex-flow: row nowrap;\r\n    align-items: center;\r\n    background-color: #ECEFF1;\r\n    color: #332D2D;\r\n    font-size: 1rem;\r\n    padding: 0.5rem 1.5rem;\r\n    margin: 0 0 1rem;\r\n    border-radius: 1rem;\r\n}\r\n\r\n.task.critical-priority {\r\n    background-color: #FFEBEE;\r\n}\r\n\r\n.task.high-priority {\r\n    background-color: #FFF3E0;\r\n}\r\n\r\n.task.medium-priority {\r\n    background-color: #FFFDE7;\r\n}\r\n\r\n.task.low-priority {\r\n    background-color: #E3F2FD;\r\n}\r\n\r\n.task.completed {\r\n    background-color: #DCEDC8;\r\n}\r\n\r\n.task-status {\r\n    margin-right: 2rem;\r\n}\r\n\r\n.task-status-checkbox {\r\n    appearance: none;\r\n    /* Hide the default look of the checkbox*/\r\n    cursor: pointer;\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    border: 2px solid #304FFE;\r\n    border-radius: 0.5rem;\r\n    transition: border-color 0.3s ease;\r\n}\r\n\r\n.task-status-checkbox:hover {\r\n    background-color: white;\r\n}\r\n\r\n.task-status-checkbox:checked {\r\n    background-color: #14A44D;\r\n    border-color: #14A44D;\r\n}\r\n\r\n.task-body {\r\n    margin-right: auto;\r\n}\r\n\r\n.task-title,\r\n.task-description {\r\n    margin: 0;\r\n    font-size: 1rem;\r\n}\r\n\r\n.task.completed .task-title,\r\n.task.completed .task-description {\r\n    text-decoration: line-through;\r\n}\r\n\r\n.task-title {\r\n    font-weight: bold;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.task-description {\r\n    font-weight: normal;\r\n}\r\n\r\n.task-action {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.task-action-date,\r\n.task-action-btn {\r\n    cursor: pointer;\r\n    padding: 0.5rem 1rem;\r\n    border: none;\r\n    background-color: transparent;\r\n    overflow: hidden;\r\n    transition: background 0.3s ease;\r\n}\r\n\r\n.task-action-date {\r\n    font-size: 1rem;\r\n    border-radius: 0.25rem;\r\n}\r\n\r\n.task-action-btn {\r\n    display: inline-block;\r\n    margin-left: 1rem;\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.task.completed .task-action-date,\r\n.task.completed .edit-btn {\r\n    opacity: 0.5;\r\n}\r\n\r\n.task-action-date:hover,\r\n.task-action-date:active,\r\n.task-action-btn:hover,\r\n.task-action-btn:active {\r\n    background-color: white;\r\n}\r\n\r\n.task.completed .task-action-date:hover,\r\n.task.completed .edit-btn:hover {\r\n    background-color: transparent;\r\n    cursor: default;\r\n}\r\n\r\n.task-icon {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n/* Modal */\r\n.task-modal {\r\n    width: min(1000px, 98vw);\r\n    background-color: #FBFBFB;\r\n    border: none;\r\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\r\n    padding: 1rem;\r\n}\r\n\r\n.task-modal .modal-header {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.task-modal .close-btn {\r\n    text-align: center;\r\n    flex-grow: 0;\r\n    margin-left: auto;\r\n    cursor: pointer;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: #9E9E9E;\r\n    font-size: 1.5rem;\r\n    transition: color 0.3s ease;\r\n}\r\n\r\n.task-modal .close-btn:hover,\r\n.task-modal .close-btn:active {\r\n    color: #262626;\r\n}\r\n\r\n.task-modal .modal-title {\r\n    font-weight: bold;\r\n    font-size: 1.5rem;\r\n    margin: 0;\r\n    text-align: center;\r\n    flex-grow: 1;\r\n}\r\n\r\n.task-modal .modal-title::first-letter {\r\n    text-transform: uppercase;\r\n}\r\n\r\n::backdrop {\r\n    background-color: #CFD8DC;\r\n    opacity: 0.5;\r\n}\r\n\r\n/* Footer */\r\n.footer-text {\r\n    font-size: 1rem;\r\n    font-weight: normal;\r\n    color: #757575;\r\n    font-family: inherit;\r\n}\r\n\r\n/* Animation */\r\n.btn {\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.btn span {\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n    width: 100px;\r\n    height: 100px;\r\n    margin-top: -50px;\r\n    margin-left: -50px;\r\n    animation: ripple 1s;\r\n    opacity: 0;\r\n}\r\n\r\n/* Add animation */\r\n@keyframes ripple {\r\n    from {\r\n        opacity: 1;\r\n        transform: scale(0);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        transform: scale(10);\r\n    }\r\n}\r\n\r\n/* HD+ Devices */\r\n@media only screen and (max-width: 1910px) {\r\n    .sidebar {\r\n        padding: 2rem 0.5rem;\r\n    }\r\n\r\n    .task {\r\n        width: 90%;\r\n    }\r\n\r\n    .content {\r\n        padding: 2rem 4rem;\r\n    }\r\n}\r\n\r\n/* HD Devices */\r\n@media only screen and (max-width: 1590px) {\r\n    .sidebar {\r\n        padding: 2rem 0.5rem;\r\n    }\r\n\r\n    .task {\r\n        width: 100%;\r\n    }\r\n\r\n    .content {\r\n        padding: 2rem 4rem;\r\n    }\r\n}\r\n\r\n/* Large Devices */\r\n@media only screen and (max-width: 1199px) {\r\n\r\n    /* Layout */\r\n    .sidebar {\r\n        padding: 1.5rem 0.5rem;\r\n    }\r\n\r\n    .footer {\r\n        padding: 1rem 0;\r\n    }\r\n\r\n    /* Sidebar */\r\n    .sidebar-task {\r\n        margin: 0 0 1rem;\r\n    }\r\n\r\n    .sidebar-title {\r\n        font-size: 1.25rem;\r\n        margin: 0.75rem 2rem;\r\n    }\r\n\r\n    .nav-item,\r\n    .project-item {\r\n        width: 220px;\r\n        font-size: 0.75rem;\r\n        margin: 0 0 0.7rem;\r\n    }\r\n\r\n    .nav-item {\r\n        padding: 0.35rem 3rem 0.35rem 1.5rem;\r\n    }\r\n\r\n    .project-item {\r\n        padding: 0.35rem 0.25rem 0.35rem 0.75rem;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .project-action-btn {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .project-form {\r\n        margin: 0 0.75rem 1rem;\r\n    }\r\n\r\n    .form-control {\r\n        font-size: 0.75rem;\r\n        padding: 6px 10px;\r\n    }\r\n\r\n    .add-btn,\r\n    .cancel-btn {\r\n        padding: 0.5rem 1rem;\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    /* Content */\r\n    .content {\r\n        padding: 1.5rem 3rem;\r\n    }\r\n\r\n    .content-title {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .add-task-btn {\r\n        padding: 0.5rem 4rem 0.5rem 1rem;\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .insert-task-form {\r\n        width: 100%;\r\n        margin: 1.5rem auto;\r\n        padding: 1.5rem 2rem;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .task-details,\r\n    .task-metadata {\r\n        gap: 1.5rem;\r\n    }\r\n\r\n    .insert-task-form .group-btn {\r\n        gap: 2rem;\r\n    }\r\n\r\n    /* Task */\r\n    .task {\r\n        width: 100%;\r\n        font-size: 0.75rem;\r\n        padding: 0.5rem 1rem;\r\n    }\r\n\r\n    .task-status-checkbox {\r\n        width: 1rem;\r\n        height: 1rem;\r\n    }\r\n\r\n    .task-title,\r\n    .task-description {\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    .task-action-date,\r\n    .task-action-btn {\r\n        padding: 0.35rem 0.7rem;\r\n    }\r\n\r\n    .task-action-date {\r\n        font-size: 0.75rem;\r\n    }\r\n    \r\n    .task-icon {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    /* Footer */\r\n    .footer-text {\r\n        font-size: 0.75rem;\r\n    }\r\n}\r\n\r\n/* Medium Devices */\r\n@media only screen and (max-width: 991px) {\r\n    .sidebar-project {\r\n        margin: 0;\r\n    }\r\n\r\n    /* Content */\r\n    .content {\r\n        padding: 1rem;\r\n    }\r\n}\r\n\r\n/* Small Devices */\r\n@media only screen and (max-width: 767px) {\r\n    /* Layout */\r\n    .page-wrapper {\r\n        display: flex;\r\n        flex-flow: column wrap;\r\n    }\r\n\r\n    .header {\r\n        padding: 1rem 0;\r\n        font-size: 2rem;\r\n        justify-content: center;\r\n    }\r\n\r\n    .sidebar {\r\n        display: flex;\r\n        flex-flow: row nowrap;\r\n        padding: 2rem 0;\r\n    }\r\n\r\n    .content {\r\n        margin-bottom: auto;\r\n    }\r\n\r\n    /* Sidebar */\r\n    .sidebar-task, \r\n    .sidebar-project {\r\n        flex-grow: 1;\r\n    }\r\n\r\n    .sidebar-task {\r\n        margin: 0;\r\n    }\r\n\r\n    .sidebar-title {\r\n        margin: 0 0 1rem;\r\n        text-align: center;\r\n    }\r\n\r\n    .nav-item,\r\n    .project-item {\r\n        width: 100%;\r\n    }\r\n\r\n    /* Content */\r\n    .content {\r\n        padding: 1rem 0;\r\n    }\r\n\r\n    /* Task */\r\n    .task {\r\n        display: grid;\r\n        grid-template-rows: auto auto;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n\r\n    .task-action {\r\n        grid-column: span 2;\r\n        margin-top: 0.5rem;\r\n        justify-content: center;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
